import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from '@material-ui/core/Tooltip';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import User from "../UserMenu/User";
import HeaderInfo from './Info';
import { useDrawerProvider } from "../../providers/DrawerContext";
import { actions } from "../../actions/drawer";
import { useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from "@material-ui/core";
import { useMenuProvider } from '../../providers/MenuContext';
import { useCognitoProvider } from '../../providers/CognitoContext';
import { actions as cognitoActions } from '../../actions/cognito';
import { useBusinessProvider } from "../../providers/BusinessContext";

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    minHeight: drawer => drawer.barHeight,
    width: '100%',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    backgroundColor: '#ffffff',
    borderBottom: '1px solid rgba(0,0,0,0.06)',
    boxShadow: 'none',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      borderRadius: 0,
      minHeight: 0,
    },
  },
  menu: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  loading: {
    color: '#007C5A',
    width: '24px !important',
    height: '24px !important',
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
  titleDivider: {
    width: 1,
    height: 24,
    backgroundColor: 'rgba(0,0,0,0.1)',
    flexShrink: 0,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  title: {
    color: '#1a2e22',
    fontWeight: 700,
    fontSize: '1.1rem',
    letterSpacing: '-0.02em',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
  route: {
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    display: 'inline-flex',
    color: '#007C5A',
    marginRight: theme.spacing(1),
  },
  container: {
    [theme.breakpoints.up('sm')]: {
      flexWrap: 'nowrap',
      justifyContent: 'space-between',
    },
  },
  user: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  info: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    gap: theme.spacing(1),
  },
  data: {
    overflow: 'hidden',
  },
  menuButton: {
    padding: theme.spacing(1),
    marginRight: theme.spacing(1.5),
    color: '#4f6b5c',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

function Header() {

  const { currentRoute } = useMenuProvider();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up('md'));
  const { state, dispatch } = useDrawerProvider();
  const { state: cognitoState, dispatch: cognitoDispatch } = useCognitoProvider();
  const { state: businessState } = useBusinessProvider();
  const classes = useStyles(state);

  useEffect(() => {
    cognitoDispatch({ type: cognitoActions.LOADING, payload: true });
  }, []);

  useEffect(() => {
    if (cognitoState.business !== '' && cognitoState.loading) {
      cognitoDispatch({ type: cognitoActions.LOADING, payload: false });
    }
  }, [cognitoState]);

  const handleDrawer = () => dispatch({ type: actions.HANDLE_MENU, payload: !state.open });
  const handleDrawerDesktop = () => dispatch({ type: actions.HANDLE_MENU_DESKTOP, payload: !state.openDesktop });

  return (
    <Grid container direction="column">
      <Box component={Card} square elevation={0} className={classes.root}>
        <Grid className={classes.container} container alignItems="center" direction="row">
          <div className={classes.menu}>
            <IconButton
              className={classes.menuButton}
              onClick={matches ? handleDrawerDesktop : handleDrawer}
            >
              <MenuIcon />
            </IconButton>
          </div>
          <div className={classes.route}>
            <Typography className={classes.title} component="h1" variant="h1" noWrap>
              {currentRoute.name}
            </Typography>
          </div>
          <div className={classes.info}>
            <div className={classes.data}>
              {businessState.loading
                ? <CircularProgress className={classes.loading} />
                : <Tooltip title={`${cognitoState.business} (${cognitoState.codOperator})`} arrow>
                    <HeaderInfo />
                  </Tooltip>
              }
            </div>
            <div className={classes.titleDivider} />
            <div className={classes.user}>
              <User />
            </div>
          </div>
        </Grid>
      </Box>
    </Grid>
  );
}

export default Header;
